import {atom} from 'jotai';

export const isUserLoggedInAtom = atom(false);

export const userAtom = atom<any>({});
